import { createQuery, createSuspenseQuery } from 'react-query-kit';

import {
  CONTENT_CACHE_OPTIONS,
  NON_CRITICAL_CONTENT_QUERY_OPTIONS,
} from '@/api/contentQueryDefaults';
import { SCHOOL_SELECTION_INFO } from '@/shared/category/schoolSelection.const';
import { type SelectionSchoolInfo } from '@/views/build/type';

// 학교/출판사 선택 데이터는 위글루 → 코드 상수로 내장(SCHOOL_SELECTION_INFO).
// fetcher 가 네트워크 대신 상수를 반환하지만 react-query 훅 구조를 유지해
// 소비처(캐시 getQueryData 포함) 변경이 0 이다. 더 이상 원격 조회가 아니므로
// 위글루 entryId 변수는 없앤다 — 남겨두면 cms-migrate 인벤토리 스캐너가
// 여전히 활성 위글루 후보로 오판한다. 훅/키 이름의 zepetoful 접두어는
// 후속 리네이밍 정리 대상.
export const ZepetofulSchoolContentQueryOptions = {
  queryKey: ['zepetoful-school-content'],
  fetcher: async (): Promise<SelectionSchoolInfo> => SCHOOL_SELECTION_INFO,
};

export const useZepetofulSuspenseSchoolContent = createSuspenseQuery<
  SelectionSchoolInfo,
  void
>({
  ...ZepetofulSchoolContentQueryOptions,
  // suspense 는 로컬 ErrorBoundary(withAsyncBoundary)로 감싸져 있어 캐싱만 강화한다.
  ...CONTENT_CACHE_OPTIONS,
});

export const useZepetofulFetchSchoolContent = createQuery<
  SelectionSchoolInfo,
  void
>({
  ...ZepetofulSchoolContentQueryOptions,
  // 비-suspense 라 전역 throwOnError:true 를 상속하면 500 시 페이지가 죽는다 → 방어.
  ...NON_CRITICAL_CONTENT_QUERY_OPTIONS,
});

export const getZepetofulFetchSchoolContentQueryKey = () => {
  return useZepetofulFetchSchoolContent.getKey();
};
